import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { Sport, SportData } from '@/types/sports.model';

const SPORT_FIELDS_MINIMAL = {
  uid: true,
  name: true,
} as const;

const SPORT_FIELDS_BASIC = {
  ...SPORT_FIELDS_MINIMAL,
} as const;

const SPORT_FIELDS_DEFAULT = {
  ...SPORT_FIELDS_BASIC,
} as const;

const SPORT_FIELDS_FULL: CompleteFieldSelector<Sport> = {
  ...SPORT_FIELDS_DEFAULT,
} as const;

const SPORT_DATA_FIELDS_FULL: CompleteFieldSelector<SportData> = {
  sport: SPORT_FIELDS_FULL,
  data: {
    court: {
      surface: true,
      wallType: true,
    },
  },
} as const;

export const SPORT_FIELDS = {
  MINIMAL: SPORT_FIELDS_MINIMAL,
  BASIC: SPORT_FIELDS_BASIC,
  DEFAULT: SPORT_FIELDS_DEFAULT,
  FULL: SPORT_FIELDS_FULL,
} as const;

export const SPORT_DATA_FIELDS = {
  FULL: SPORT_DATA_FIELDS_FULL,
} as const;

// RankingDTO nests the sport rather than flattening it. Declared once because three configs had
// already drifted to a flat spread, which silently dropped `sport` from the response.
export const RANKING_FIELDS = {
  BASIC: {
    elo: true,
    sport: SPORT_FIELDS_BASIC,
  },
} as const;
